import MenuItem from '../MenuItem/menu-item';

export default MenuItem;